export function debounce<T extends (...args: unknown[]) => unknown>(
  callback: T,
  delay = 500,
): ((...args: Parameters<T>) => void){
  let timeoutId: number;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => callback(...args), delay);
  }
}
